/* eslint-disable */
export default {
  dncAlert: '這位連絡人在不要來電的名單中。',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
